var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: "关联商品", visible: _vm.dialogVisible, width: "1000px" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "relation-dialog-content" }, [
        _c(
          "div",
          { staticClass: "form-row" },
          [
            _c("span", { staticClass: "required-star" }, [_vm._v("*")]),
            _vm._v(" "),
            _c("span", { staticClass: "row-label" }, [_vm._v("主商品")]),
            _vm._v(" "),
            _c("el-input", {
              staticClass: "main-goods-select",
              attrs: { disabled: "", size: "small" },
              model: {
                value: _vm.mainGoodsName,
                callback: function ($$v) {
                  _vm.mainGoodsName = $$v
                },
                expression: "mainGoodsName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "relation-section" }, [
          _c("div", { staticClass: "relation-header" }, [
            _c("span", { staticClass: "required-star" }, [_vm._v("*")]),
            _vm._v(" "),
            _c("span", { staticClass: "row-label" }, [
              _vm._v("关联子商品及数量"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relation-filters" },
            [
              _c("span", { staticClass: "required-star" }, [_vm._v("*")]),
              _vm._v(" "),
              _c("span", { staticClass: "filter-label" }, [_vm._v("业务类型")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "business-type-select",
                  attrs: { size: "small", placeholder: "请选择" },
                  model: {
                    value: _vm.businessType,
                    callback: function ($$v) {
                      _vm.businessType = $$v
                    },
                    expression: "businessType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "团购", value: 2 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "酒店", value: 3 } }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  staticClass: "search-goods-input",
                  attrs: {
                    size: "small",
                    placeholder: "搜索商品名称",
                    "prefix-icon": "el-icon-search",
                    clearable: "",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleSearchGoods($event)
                    },
                  },
                  model: {
                    value: _vm.searchKeyword,
                    callback: function ($$v) {
                      _vm.searchKeyword = $$v
                    },
                    expression: "searchKeyword",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    staticStyle: { cursor: "pointer" },
                    attrs: { slot: "suffix" },
                    on: { click: _vm.handleSearchGoods },
                    slot: "suffix",
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showGoodsList
            ? _c(
                "div",
                { staticClass: "goods-list-area" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.goodsLoading,
                          expression: "goodsLoading",
                        },
                      ],
                      staticClass: "goods-table",
                      attrs: {
                        data: _vm.pagedGoodsList,
                        size: "mini",
                        border: "",
                        "max-height": "200",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "spuId",
                          label: "SPU ID",
                          width: "90",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goodsName",
                          label: "商品名称",
                          "min-width": "160",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "storeName",
                          label: "店铺名称",
                          "min-width": "140",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "price",
                          label: "价格",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", { staticClass: "price-text" }, [
                                    _vm._v(
                                      "¥" +
                                        _vm._s(
                                          Number(scope.row.price).toFixed(2)
                                        )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          601923148
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "90", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "mini",
                                        disabled: _vm.isGoodsSelected(
                                          scope.row.id
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleAddGoods(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isGoodsSelected(scope.row.id)
                                            ? "已添加"
                                            : "添加"
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2050241926
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.goodsTotal > _vm.pageSize
                    ? _c("el-pagination", {
                        staticClass: "goods-pagination",
                        attrs: {
                          small: "",
                          layout: "prev, pager, next",
                          total: _vm.goodsTotal,
                          "page-size": _vm.pageSize,
                          "current-page": _vm.goodsPage,
                        },
                        on: { "current-change": _vm.handleGoodsPageChange },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedGoodsList.length
            ? _c("div", { staticClass: "selected-goods-section" }, [
                _c("div", { staticClass: "selected-header" }, [
                  _c("span", [_vm._v("已选关联商品（上限50个）")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "selectedListRef", staticClass: "selected-list" },
                  _vm._l(_vm.selectedGoodsList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "selected-item",
                        class: { "is-dragging": _vm.dragIndex === index },
                        attrs: { draggable: "true" },
                        on: {
                          dragstart: function ($event) {
                            return _vm.handleDragStart(index, $event)
                          },
                          dragover: function ($event) {
                            $event.preventDefault()
                            return _vm.handleDragOver(index)
                          },
                          dragend: _vm.handleDragEnd,
                        },
                      },
                      [
                        _c("div", { staticClass: "item-drag" }, [
                          _c("i", { staticClass: "el-icon-rank" }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "item-info" }, [
                          _c("span", { staticClass: "item-spu-id" }, [
                            _vm._v(_vm._s(item.spuId)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "item-name" }, [
                            _vm._v(_vm._s(item.goodsName)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "item-store-name",
                              attrs: { title: item.storeName },
                            },
                            [_vm._v(_vm._s(item.storeName || "-"))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "item-price" }, [
                            _vm._v("¥" + _vm._s(Number(item.price).toFixed(2))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "item-limit" },
                            [
                              _c("el-input", {
                                staticClass: "limit-input",
                                attrs: {
                                  type: "number",
                                  min: 1,
                                  max: 999,
                                  size: "mini",
                                  value: item.reserveLimit,
                                  disabled: item.unlimited,
                                },
                                on: {
                                  change: function (val) {
                                    return _vm.handleLimitChange(item.id, val)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-checkbox",
                                {
                                  staticClass: "unlimited-check",
                                  attrs: { value: item.unlimited },
                                  on: {
                                    change: function (val) {
                                      return _vm.handleUnlimitedChange(
                                        item.id,
                                        val
                                      )
                                    },
                                  },
                                },
                                [_vm._v("不限次数")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "item-actions" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "delete-btn",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRemoveGoods(item.id)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "el-icon-close" })]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.pagedGoodsList.length && !_vm.selectedGoodsList.length
            ? _c("div", { staticClass: "empty-tip" }, [
                _c("i", { staticClass: "el-icon-folder-opened" }),
                _vm._v(" "),
                _c("span", [_vm._v("暂无商品")]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "relation-summary" }, [
          _vm._v("\n      已关联 "),
          _c("span", { staticClass: "count-num" }, [
            _vm._v(_vm._s(_vm.selectedGoodsList.length)),
          ]),
          _vm._v(" 个商品\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "relation-tip" }, [
          _c("i", { staticClass: "el-icon-warning" }),
          _vm._v(" "),
          _c("span", [
            _vm._v("注意：此页面排序将影响小程序一卡通预约商品排序"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.submitting,
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确认关联")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }